export default "__VITE_ASSET__U8kBeoR9__"